import { z } from 'zod';
export const decryptDriverLicenseParamsSchema = z.object({
    driverLicenseHash: z.string().min(1),
    personId: z.string().optional(),
});
export const decryptDriverLicenseFunctionDef = {
    name: 'decryptDriverLicense',
    requestSchema: decryptDriverLicenseParamsSchema,
    responseSchema: z.string(),
};
